import { useInView } from "react-intersection-observer";
import { useEffect, type ReactNode } from "react";

interface Props {
  hasMore: boolean;
  next: () => void;
  loadingComponent?: ReactNode;
  children: ReactNode;
  rootMargin?: string;
}

export const InfiniteScroll = ({
  hasMore,
  next,
  loadingComponent,
  children,
  rootMargin = "200px",
}: Props) => {
  const { ref, inView } = useInView({
    rootMargin,
  });

  useEffect(() => {
    if (inView && hasMore) {
      next();
    }
  }, [inView, hasMore, next]);

  return (
    <>
      {children}
      <div ref={ref}>
      {hasMore && loadingComponent}
      </div>
    </>
  );
};
